import React from 'react';
import { Icon } from './Icon.js';
export const IconGem = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M10 3L8 9L11.5042 20.4201", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M14 3L16 9L12.4812 20.4305", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M22 9H2", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M6 3L2 9L12 21L22 9L18 3H6Z", stroke: "currentColor", strokeWidth: "2", fill: "none" })));
};
//# sourceMappingURL=IconGem.js.map